
import React from 'react';
import { Download } from "lucide-react";

export const CaseStudiesPreview: React.FC = () => {
  return (
    <section className="mb-16">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">Five Real-World Case Studies</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-white/5 backdrop-blur-sm p-6 rounded-lg border border-white/10">
          <h3 className="text-lg font-bold mb-2">Client Intake Automation</h3>
          <p className="text-white/80 mb-4">
            Learn how a solo practice automated 90% of its client acquisition process, 
            enabling 24/7 availability without adding staff.
          </p>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Download size={16} />
            <span>Full details in the report</span>
          </div>
        </div>
        
        <div className="bg-white/5 backdrop-blur-sm p-6 rounded-lg border border-white/10">
          <h3 className="text-lg font-bold mb-2">E-Discovery Revolution</h3>
          <p className="text-white/80 mb-4">
            Discover how a boutique firm processes millions of documents in minutes 
            during trial, competing with larger firms' resources.
          </p>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Download size={16} />
            <span>Full details in the report</span>
          </div>
        </div>
        
        <div className="bg-white/5 backdrop-blur-sm p-6 rounded-lg border border-white/10">
          <h3 className="text-lg font-bold mb-2">Medical Malpractice Analysis</h3>
          <p className="text-white/80 mb-4">
            See how AI helped a small firm uncover critical findings in complex medical 
            records that would have taken days to review manually.
          </p>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Download size={16} />
            <span>Full details in the report</span>
          </div>
        </div>
        
        <div className="bg-white/5 backdrop-blur-sm p-6 rounded-lg border border-white/10">
          <h3 className="text-lg font-bold mb-2">Practice Automation</h3>
          <p className="text-white/80 mb-4">
            Explore how a family law practice used AI to offer unbundled services 
            at affordable rates while increasing profitability.
          </p>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Download size={16} />
            <span>Full details in the report</span>
          </div>
        </div>
        
        <div className="bg-white/5 backdrop-blur-sm p-6 rounded-lg border border-white/10 md:col-span-2">
          <h3 className="text-lg font-bold mb-2">Contract Drafting Efficiency</h3>
          <p className="text-white/80 mb-4">
            Find out how an estate planning firm saves 1-2 hours daily on drafting 
            documents while reducing errors and improving consistency.
          </p>
          <div className="flex items-center gap-2 text-sm text-primary">
            <Download size={16} />
            <span>Full details in the report</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesPreview;
